import { render, staticRenderFns } from "./RiskIdentificationEditView.vue?vue&type=template&id=80e09178&"
import script from "./RiskIdentificationEditView.vue?vue&type=script&lang=ts&"
export * from "./RiskIdentificationEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports